import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import MuiCheckbox from '@mui/material/Checkbox';
import MuiFormGroup from '@mui/material/FormGroup';
import MuiFormHelperText from '@mui/material/FormHelperText';
import * as React from 'react';
import { FormControlLabel } from '../form-control';
import { FieldSkeleton } from '../textfield/utils';
import { firstLetterUppercase, sentence, Typography } from '../typography';
import { makeEnum, withVersion } from '../utils';
import { CheckboxGroupContext } from './context';
export { CheckboxGroupContext } from './context';
const sizes = ['small', 'medium', 'large'];
export const CheckboxSize = makeEnum(...sizes);
export const Checkbox = withVersion((props) => {
    const { label, labelProps, error, onChange, helperText, skeleton = false, ...muiProps } = props;
    const inGroup = React.useContext(CheckboxGroupContext);
    const control = (_jsx(MuiCheckbox, { onChange: (e) => onChange?.(e.target.checked, e), ...muiProps }));
    const wrapSkeleton = (content) => skeleton ? (_jsx(FieldSkeleton, { width: "fit-content", children: content })) : (content);
    if (!label) {
        return wrapSkeleton(control);
    }
    const labelNode = (_jsxs(_Fragment, { children: [_jsx(FormControlLabel, { ...labelProps, control: control, label: _jsx(Typography, { textTransform: "sentence", color: muiProps.disabled ? 'text.disabled' : undefined, children: label }), disableTypography: true }), error ? (_jsx(MuiFormHelperText, { error: true, children: sentence(error) })) : (helperText && (_jsx(MuiFormHelperText, { sx: { ...firstLetterUppercase }, children: helperText })))] }));
    if (inGroup) {
        return wrapSkeleton(labelNode);
    }
    return wrapSkeleton(_jsx(MuiFormGroup, { children: labelNode }));
}, '1.0.0');
export { CheckboxGroup } from './CheckboxGroup';
export const checkboxStyle = {
    MuiCheckbox: {
        styleOverrides: {
            root: {
                '& input[type=checkbox]': {
                    marginTop: 0
                }
            }
        }
    }
};
